import React from 'react';
import { Affix } from 'antd';
import routeLocations from '../../utility/route-locations';
import { ViaLogo, LogoLocations } from '../logo/ViaLogo';

/**
 * A simple header for non-authenticated users.
 */
export default function ViaHeader() {
  return (// Ant messages and notifications have z-index of 1010 so dont make this any higher than that!
    <header style={{ zIndex: '999' }}>
      <Affix offsetTop={0} style={{ height: '50px' }}>
        <div className="via-header-layout">
          <div className="via-header-view center">
            <ViaLogo href={routeLocations.dashboard} logoSrc={LogoLocations.NORMAL_BLUE_CIRCLE_WHITE_M} className="via-header-logo" />
          </div>
        </div>
      </Affix>
    </header>
  );
}
